module.exports = __webpack_public_path__ + "img/CAWalkingAnimation.95d1f068.gif";